import { Link } from "wouter";
import { useState } from "react";
import { X } from "lucide-react";
import headshotUrl from "/brennan-headshot.webp";

export default function FloatingCTABanner() {
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <aside aria-label="Schedule a demo" className="fixed bottom-2 left-2 right-2 z-40 flex max-w-[calc(100vw-1rem)] flex-nowrap items-center gap-1.5 rounded-full border border-[#333] bg-[#222222] px-2.5 py-2 shadow-2xl shadow-black/50 backdrop-blur-sm pb-[max(0.5rem,env(safe-area-inset-bottom))] sm:bottom-6 sm:left-6 sm:right-auto sm:max-w-none sm:gap-3 sm:px-4 sm:py-3 sm:pb-[max(0.75rem,env(safe-area-inset-bottom))]">
      <div className="relative flex-shrink-0">
        <img
          src={headshotUrl}
          alt="Brennan Ursu"
          width="48"
          height="48"
          className="h-8 w-8 rounded-full object-cover object-top ring-2 ring-[#FF6B00]/60 sm:h-12 sm:w-12"
        />
        <span aria-hidden="true" className="absolute -bottom-0.5 -right-0.5 h-3 w-3 rounded-full border-2 border-[#222] bg-green-500 sm:h-3.5 sm:w-3.5" />
      </div>

      <div className="min-w-0">
        <div className="whitespace-nowrap text-xs font-black leading-tight text-white sm:text-sm">
          Give us a call!
        </div>
        <div className="truncate text-[11px] leading-tight text-[#a89e95] sm:text-xs">Brennan Ursu, CEO</div>
      </div>

      <Link
        to="/book-demo?source=Floating%20demo%20bar"
        className="ml-auto flex flex-shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-[#FF6B00] min-h-10 px-3 py-2 text-xs font-black text-[#1A1A1A] transition-colors hover:bg-[#e8590c] sm:ml-1 sm:gap-2 sm:px-5 sm:py-2.5 sm:text-sm"
      >
        Set Up a Demo
        <span aria-hidden="true" className="text-[9px] sm:text-[10px]">▶</span>
      </Link>
      <button
        type="button"
        aria-label="Dismiss demo invitation"
        onClick={() => setDismissed(true)}
        className="flex h-10 w-10 -mr-1 flex-shrink-0 items-center justify-center rounded-full text-white hover:bg-white/10 sm:mr-0 sm:h-8 sm:w-8"
      >
        <X aria-hidden="true" className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
      </button>
    </aside>
  );
}
